import { usePlane } from "@react-three/cannon";
import { useRef } from "react";
import { Mesh } from "three";
import { ObjectProps } from "../utils";

export default (props: ObjectProps) => {
  const [ref] = usePlane(() => ({ ...props }), useRef<Mesh>(null));
  return (
    <mesh ref={ref} receiveShadow>
      <planeGeometry args={[1000, 1000]} />
      <meshStandardMaterial color="#555555" />
    </mesh>
  );
};
